<template>
  <div>
    <v-text-field v-model="form.name"
                  label="Name"
                  placeholder="Give this snippet a descriptive name"
                  :rules="[rules.required]"
                  :error-messages="form.errors.get('name')"
                  :counter="100"
                  outlined>
    </v-text-field>

    <p v-if="1===2">
      <v-btn @click.prevent="openTagsDialog()">
        Insert Tag
      </v-btn>
    </p>
    <v-textarea v-model="form.content"
                ref="textArea"
                label="Snippet text"
                placeholder="What is the text of the snippet?"
                rows="6"
                :rules="[rules.required]"
                :error-messages="form.errors.get('content')"
                :counter="1000"
                autocomplete="off"
                autocorrect="off"
                autocapitalize="off"
                outlined>
    </v-textarea>

    <v-switch v-model="form.is_active"
              :label="form.is_active ? 'Active' : 'Inactive'"
              :error-messages="form.errors.get('is_active')">
    </v-switch>

    <div class="mb-4">
      <v-dialog v-model="tagsDialog"
                scrollable
                max-width="90%">
        <v-card>
          <v-card-title class="primary white--text">
            Tags
            <v-spacer></v-spacer>
            <v-btn @click.prevent="closeTagsDialog()">
              Close
            </v-btn>
          </v-card-title>
          <v-card-text>
            <div class="ml-4 mt-4">
              Mobile Locker user the <a href="https://shopify.github.io/liquid/basics/introduction/"
                                        target="_blank">Liquid template language</a>.
            </div>
            <tags-table @selected="insertSelectedTag">
            </tags-table>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>

import TagsTable from '../../../../share_templates/components/TagsTable';
import formValidation from '../../../../../plugins/formValidation';

export default {
  mixins: [formValidation],
  components: {TagsTable},
  props: {
    form: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      editor: null,
      mounted: false,
      tagsDialog: false,
    }
  },
  computed: {

  },
  created() {

  },
  mounted() {
    this.mounted = true;
  },
  methods: {
    closeTagsDialog() {
      this.tagsDialog = false
    },
    openTagsDialog() {
      this.tagsDialog = true;
    },
    insertSelectedTag(content) {
      // @see https://stackoverflow.com/questions/48145727/insert-character-at-cursor-position-in-vue-js
      // @see https://stackoverflow.com/questions/50103339/vuejs-vuetify-add-some-text-to-focus-position-on-textarea
      // @see https://stackoverflow.com/questions/55374961/bootstrap-vue-textarea-selectionstart-is-nan-or-undefined
      this.closeTagsDialog();
      if (this.$refs.textArea && this.$refs.textArea.$refs.input) {
        const tArea = this.$refs.textArea.$refs.input;
        try {
          let cursorPos;

          // get cursor's position:
          let startPos = tArea.selectionStart;
          let endPos = tArea.selectionEnd;

          cursorPos = startPos;
          let tmpStr = tArea.value;

          // insert:
          this.form.content = tmpStr.substring(0, startPos) + content + tmpStr.substring(endPos, tmpStr.length);

          // move cursor:
          setTimeout(() => {
            cursorPos += content.length;
            tArea.selectionStart = tArea.selectionEnd = cursorPos;
            tArea.focus();
          }, 10);
        } catch (err) {
          console.log(err.message);
        }
      }
    }
  }
}
</script>
